export default function MySQL_Intro() {
  return (
    <div>
      <h2>MySQL_Intro</h2>    </div>
  );
}